"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PlayRoundIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16A8 8 0 108 0a8 8 0 000 16zm2.872-8.727a.902.902 0 010 1.575L6.718 11.21c-.615.35-1.385-.087-1.385-.787V5.698c0-.7.77-1.137 1.385-.787l4.154 2.362z",
    clipRule: "evenodd"
  })))
});
PlayRoundIcon.displayName = 'PlayRoundIcon';
var _default = exports.default = PlayRoundIcon;